import { Box, Stack } from '@mui/material'
import { Footer, LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'
import { ReactNode } from 'react'

export default function ValueCheckPageLayoutLoading({ breadcrumbs }: { breadcrumbs: ReactNode }) {
    return (
        <Stack direction="column" minHeight="100%" bgcolor={tokens.ColorBackgroundDark}>
            <Stack direction="column" gap={tokens.SizingSpacing300}>
                <PageGridContainer background={`linear-gradient(${tokens.ColorBackgroundLight} 235.5px, transparent 235.5px)`}>
                    <PageGridItem columnSpan={6} columnSpanXs={4}>
                        <Stack direction="column" gap={tokens.SizingSpacing400}>
                            <Stack
                                direction="row"
                                paddingTop={tokens.SizingSpacing200}
                                paddingBottom={tokens.SizingSpacing300}
                                gap={tokens.SizingSpacing300}
                                width="100%"
                                alignItems="flex-end"
                            >
                                <Stack direction="column" flexGrow={1} gap={tokens.SizingSpacing300}>
                                    {breadcrumbs}
                                    <Stack direction="row">
                                        <Stack direction="column" gap={tokens.SizingSpacing200} width="100%">
                                            <Stack direction="column" gap={tokens.SizingSpacing075}>
                                                <LoadingSkeleton variant="rounded" height="24px" width="120px" />
                                                <LoadingSkeleton variant="rounded" height="34px" width="340px" />
                                                <LoadingSkeleton variant="rounded" height="34px" width="300px" />
                                            </Stack>
                                            <LoadingSkeleton variant="rounded" height="32px" width="430px" />
                                        </Stack>
                                        <Stack
                                            direction="column"
                                            alignItems="flex-end"
                                            flexGrow={1}
                                            minHeight="100%"
                                            gap={tokens.SizingSpacing800}
                                        >
                                            <Stack direction="row" gap={tokens.SizingSpacing150} alignItems="center">
                                                <LoadingSkeleton variant="rounded" height="32px" width="77px" />
                                                <LoadingSkeleton variant="rounded" height="32px" width="174px" />
                                            </Stack>
                                            <Stack direction="column" alignItems="flex-end" flexGrow={1} gap={tokens.SizingSpacing200}>
                                                <LoadingSkeleton variant="rounded" height="24px" width="150px" />
                                                <LoadingSkeleton variant="rounded" height="24px" width="150px" />
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Stack>
                                <div style={{ backgroundColor: tokens.ColorBackgroundDark }}>
                                    <LoadingSkeleton variant="rounded" width="255px" height="170px" />
                                </div>
                            </Stack>
                        </Stack>
                    </PageGridItem>
                </PageGridContainer>
                <PageGridContainer>
                    <PageGridItem columnSpan={6} columnSpanXs={4}>
                        <Stack direction="column" gap={tokens.SizingSpacing300}>
                            <Stack direction="row" gap={tokens.SizingSpacing300}>
                                <Box sx={{ flexGrow: 2 }}>
                                    <LoadingSkeleton height="251px" width="100%" variant="rounded" />
                                </Box>
                                <Box sx={{ flexGrow: 1 }}>
                                    <LoadingSkeleton height="251px" width="100%" variant="rounded" />
                                </Box>
                            </Stack>
                            <LoadingSkeleton height="381px" width="100%" variant="rounded" />
                            <LoadingSkeleton height="540px" width="100%" variant="rounded" />
                        </Stack>
                    </PageGridItem>
                </PageGridContainer>
            </Stack>

            <Footer withTopSpace />
        </Stack>
    )
}
